module.exports = __webpack_public_path__ + "img/top3.46aad9a9.png";